<template>
<div class="chapter">
<div class="inner_page">
<section>
<h2 class="toc_head"><span class="right_1" epub:type="pagebreak" id="page_iii" title="iii">CONTENTS</span></h2>
<p class="toc_ch_mi"><a href="#/text/9780369702654_Chapter01">Chapter 1</a></p>
<p class="toc_ch_mi"><a href="#/text/9780369702654_Chapter02">Chapter 2</a></p>
<p class="toc_ch_mi"><a href="#/text/9780369702654_Chapter03">Chapter 3</a></p>
<p class="toc_ch_mi"><span href="#/text/9780369702654_Chapter04" title="Link target outside of Sample">Chapter 4</span></p>
<p class="toc_ch_mi"><span href="#/text/9780369702654_Chapter05" title="Link target outside of Sample">Chapter 5</span></p>
<p class="toc_ch_mi"><span href="#/text/9780369702654_Chapter06" title="Link target outside of Sample">Chapter 6</span></p>
<p class="toc_ch_mi"><span href="#/text/9780369702654_Chapter07" title="Link target outside of Sample">Chapter 7</span></p>
<p class="toc_ch_mi"><span href="#/text/9780369702654_Chapter08" title="Link target outside of Sample">Chapter 8</span></p>
<p class="toc_ch_mi"><span href="#/text/9780369702654_Chapter09" title="Link target outside of Sample">Chapter 9</span></p>
<p class="toc_ch_mi"><span href="#/text/9780369702654_Chapter10" title="Link target outside of Sample">Chapter 10</span></p>
<p class="toc_ch_mi"><span href="#/text/9780369702654_Chapter11" title="Link target outside of Sample">Chapter 11</span></p>
<p class="toc_ch_mi"><span href="#/text/9780369702654_Chapter12" title="Link target outside of Sample">Chapter 12</span></p>
<p class="toc_ch_mi"><span href="#/text/9780369702654_Chapter13" title="Link target outside of Sample">Chapter 13</span></p>
<p class="toc_ch_mi"><span href="#/text/9780369702654_Chapter14" title="Link target outside of Sample">Chapter 14</span></p>
<p class="toc_ch_mi"><span href="#/text/9780369702654_Chapter15" title="Link target outside of Sample">Chapter 15</span></p>
<p class="toc_ch_mi"><span href="#/text/9780369702654_Chapter16" title="Link target outside of Sample">Chapter 16</span></p>
<p class="toc_ch_mi"><span href="#/text/9780369702654_Chapter17" title="Link target outside of Sample">Chapter 17</span></p>
<p class="toc_ch_mi"><span href="#/text/9780369702654_Chapter18" title="Link target outside of Sample">Chapter 18</span></p>
<p class="toc_ch_mi"><span href="#/text/9780369702654_Chapter19" title="Link target outside of Sample">Chapter 19</span></p>
<p class="toc_ch_en"><span href="#/text/9780369702654_Chapter20" title="Link target outside of Sample">Chapter 20</span></p>
<p class="toc_bm"><span href="#/text/9780369702654_Backmatter01" title="Link target outside of Sample">Excerpt</span></p>
<p class="toc_bma"><span href="#/text/9780369702654_Backmatter02" title="Link target outside of Sample">Chapter One</span></p>
<p class="toc_bma"><span href="#/text/9780369702654_Backmatter03" title="Link target outside of Sample">Chapter Two</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780369702654_Contents.vue?4060c80a